import genericApi from './genericApi';

import Ports from '../models/Ports';
import ApiResponse from '../models/ApiResponse';

const portReqHandler = {

  getPorts: (direction: 'org' | 'dst'): Promise<ApiResponse<Ports>> => {
    return genericApi.get('ports?dir=' + direction);
  }
};

export default portReqHandler;